const s = {
  xxs: "xxs",
  xs: "xs",
  sm: "s",
  base: "m",
  lg: "l",
  xl: "xl",
  "2xl": "xxl",
  "3xl": "3xl",
  "4xl": "4xl",
  "5xl": "5xl"
}, e = {
  "gray-100": "grey-100",
  "gray-200": "grey-200",
  "gray-300": "grey-300",
  "gray-400": "grey-400",
  "gray-500": "grey-500",
  "gray-600": "grey-600",
  "gray-800": "grey-800",
  "gray-900": "grey-900"
}, n = {
  1: "xs",
  2: "s",
  4: "m",
  6: "l",
  8: "xl",
  10: "xxl"
};
function y(x) {
  return Object.keys(s).find((r) => s[r] === x) || x;
}
function t(x) {
  return Object.keys(e).find((r) => e[r] === x) || x;
}
function g(x) {
  return Object.keys(n).find((r) => n[r] === x) || x;
}
export {
  t as convertColors,
  y as convertFontSize,
  g as convertSpacings
};
